import React from 'react';

const DefenceStrategicStudies = () => {
  return (
    <div>
      DefenceStrategicStudies
      DefenceStrategicStudies
    </div>
  );
}

export default DefenceStrategicStudies;
